
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" fill="currentColor">
  <path d="M0.333344 3.5V13H9.83334V3.5H0.333344ZM8.77779 11.9444H1.3889V4.55556H8.77779V11.9444Z" />
  <path d="M11.9444 0.333984H4.55554V2.4451H5.6111V1.38954H11.9444V7.72287H10.8889V8.77843H13V0.333984H11.9444Z" />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'CopySimple',
    }) as DefineComponent
    </script>
    